import React, { Component } from "react";
import { formBuilderGroups } from "../../../variables/formBuilderData";
import Collapsible from "react-collapsible";
import { translate } from "../../../utils/useful";

class FormBuilderTopbar extends Component {
    state = {
        closedGroups: {},
        showChildsSide: false
    };
    onDragStart = (e, rowId, type) => {
        let dataObject = { rowId, type, dropType: "NEW" };
        if (e.dataTransfer.setData) {
            e.dataTransfer.setData(
                "dragData",
                JSON.stringify(dataObject)
            );
        } else {
            e.dataTransfer.rowId = rowId;
            e.dataTransfer.type = type;
        }
        console.log("dataObject", dataObject);
        this.props.setElDragData(dataObject);
        this.props.showhandlers();
    };


    toggleOpen = (key) => {
        let closedGroups = this.state.closedGroups
        closedGroups[key] = closedGroups[key] == null ? true : !closedGroups[key]
        this.setState({ closedGroups })
    }

    render() {
        const { formItems, hideHandlers } = this.props;

        return (

            <div className="form-column  formItems-container  bg-gray-6 " >

                <div className=" d-flex scroll-no-scrollbar w-100">



                    {formItems.map((formItem, index) => {
                        return (
                            <div className=" p-1 mb-0" style={{ width: '50%' }} key={formItem.type}>
                                <div
                                    key={index}
                                    className="form-item form-item-mobile flexcc flex-column text-smaller pt-2 pb-2"
                                    onDragStart={(e) =>
                                        this.onDragStart(e, index, formItem.type)
                                    }
                                    onDragEnd={hideHandlers}
                                    // onDragLeave={hideHandlers}
                                    draggable
                                >
                                    <img draggable={false} src={formItem.icon} height={30} />
                                    <p draggable={false} className="mt-2 text-semibold color-gray-3">{formItem.label}</p>
                                </div>
                            </div>
                        )

                    })}


                </div>
            </div>
        );
    }
}



export default FormBuilderTopbar;